"use client";
const r = Object.freeze({
  black: "rgb(39, 51, 66)",
  brand: "rgb(15, 88, 214)",
  white: "rgb(255, 255, 255)",
  blueBase: "rgb(132, 169, 233)",
  blueDark: "rgb(79, 132, 224)",
  blueDarker: "rgb(51, 85, 145)",
  greenBase: "rgb(4, 137, 66)",
  greenDark: "rgb(3, 116, 56)",
  greenDarker: "rgb(2, 89, 42)",
  orangeBase: "rgb(255, 153, 54)",
  orangeDark: "rgb(255, 128, 4)",
  orangeDarker: "rgb(255, 102, 3)",
  purpleBase: "rgb(120, 30, 147)",
  purpleLight: "rgb(241, 232, 244)",
  redBase: "rgb(204, 0, 0)",
  redDark: "rgb(173, 0, 0)",
  redDarker: "rgb(132, 0, 0)",
  yellowBase: "rgb(255, 228, 138)",
  yellowDark: "rgb(255, 215, 79)",
  yellowDarker: "rgb(255, 202, 21)",
  gray100: "rgb(235, 236, 238)",
  gray200: "rgb(226, 228, 231)",
  gray300: "rgb(213, 216, 220)",
  gray400: "rgb(199, 202, 208)",
  gray500: "rgb(170, 175, 184)",
  gray600: "rgb(128, 136, 149)",
  gray700: "rgb(103, 111, 124)",
  gray025: "rgb(248, 248, 248)",
  gray050: "rgb(246, 246, 246)",
  primary200: "rgb(231, 238, 250)",
  primary300: "rgb(207, 222, 247)",
  primary400: "rgb(159, 188, 238)",
  primary500: "rgb(98, 146, 228)",
  primary600: "rgb(15, 88, 214)",
  primary700: "rgb(12, 74, 182)",
  primary800: "rgb(9, 57, 139)"
}), g = Object.keys(r);
export {
  r as COLORS,
  g as COLOR_KEYS
};
